import { getZonedDate } from '@eika-infrastruktur/date';

import selectTransferAccounts from '../../form/selectTransferAccounts';
import { TransferAction, TransferActionType } from './actions';
import { transferInitialState, TransferState } from './state';

const reducer = (state: TransferState, action: TransferAction): TransferState => {
    switch (action.type) {
        case TransferActionType.ACCOUNT_SELECTED:
            return selectTransferAccounts(state, action.payload);

        case TransferActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case TransferActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        case TransferActionType.SHOW_TO_ACCOUNTS:
            return {
                ...state,
                showToAccounts: true,
            };
        case TransferActionType.HIDE_TO_ACCOUNTS:
            return {
                ...state,
                showToAccounts: false,
            };
        case TransferActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case TransferActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case TransferActionType.OWN_TEXT:
            return {
                ...state,
                ownText: action.payload,
            };
        case TransferActionType.TRANSFER_DATE:
            return {
                ...state,
                transferDate: action.payload,
            };
        case TransferActionType.RESET:
            return {
                ...transferInitialState,
            };
        case TransferActionType.RESET_WITH_FROM_ACCOUNT:
            return {
                ...transferInitialState,
                fromAccount: action.payload,
                transferDate: getZonedDate(),
            };
        default:
            return state;
    }
};

const transferReducer = (state: TransferState, action: TransferAction): TransferState => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cTransfer form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};

export default transferReducer;
